// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckboxLabel_root__2wyBO","nameWrap":"CheckboxLabel_nameWrap__Rv7zs","speciality":"CheckboxLabel_speciality__38sKN","requestCount":"CheckboxLabel_requestCount__1cuSW"};